export const getPredefinedColumns = () => {
    return JSON.parse(localStorage.getItem('predefinedColumns')) || [];
  };